// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '이든파마',
  targetSheetName: '적응증순',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  // 217·267행 중복 헤더 이후 블록 계속 읽기
  repeatedHeaderRowAction: 'skip',
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '기준약가',
    commissionRate: '마케팅 용역료 (부가포함)',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No.',
    '구분',
    '보험코드',
    '제품명',
    '대조약',
    '포장단위',
    '성분함량',
    '영문',
    '기준약가',
    '마케팅 용역료 (부가포함)',
    '비고',
  ],
});
